<div class="row">
    <div class="col-md-4 col-xs-12 col-sm-12 offset-md-4 mt-5">
        <mat-card class='card-size'>
            <mat-card-header>
                <mat-card-title class='text-center'>Enter below details</mat-card-title>
                <mat-card-subtitle><span class='text-danger'>*</span> All are mandatory</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                <form [formGroup]='searchCityForm' (ngSubmit)='getValue()'>
                    <div>
                        <mat-form-field class='example-full-width'>
                            <mat-label>Email</mat-label>
                            <input matInput formControlName='email' name='email' placeholder="Enter Valid Email" type='email'>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field class='example-full-width'>
                            <mat-label>Select City</mat-label>
                            <mat-select formControlName='city'>
                                <mat-option value='kanpur'>Kanpur</mat-option>
                                <mat-option value='lucknow'>Lucknow</mat-option>    
                                <mat-option value='chennai'>Chennai</mat-option>
                                <mat-option value='mumbai'>Mumbai</mat-option>
                                <mat-option value='mysore'>Mysore</mat-option>
        
        
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div>
                    <mat-checkbox (change)='enableButton()' formControlName='myValue'>Data used for General purpose only</mat-checkbox>
                    </div>
                    <button type='submit' mat-raised-button [disabled]='!searchCityForm.valid' color='primary'>Proceed</button>
                    <div></div>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>